<script lang="ts">
    import type { AudioEntry } from "@app/models/api";
    import {
        audioProgress,
        currentlyPlayedAudioFile,
        playAudioFile,
        toggleAudioPlayback,
    } from "./AudioPlayerService";

    export let audio: AudioEntry;
    export function play() {
        playAudioFile({
            url: audio.url.mp3,
            id: audio.fbFileId,
            phrase: audio.phrase,
        });
    }
    let audioElement: HTMLAudioElement;
    let playing: boolean;

    currentlyPlayedAudioFile.subscribe((audioFile) => {
        let isPlaying = false;
        if (audioFile) {
            isPlaying =
                audioFile.id === audio.fbFileId ||
                audioFile.url === audio.url.mp3;
        }

        playing = isPlaying;
    });

    function onClick(event: Event) {
        event.stopPropagation();
        event.preventDefault();
        if (playing) {
            toggleAudioPlayback();
        } else {
            play();
        }
    }
    function getAudioId(audio: AudioEntry) {
        const audioAsAny = audio as any;
        if (audioAsAny.id) {
            return audioAsAny.id;
        }
        return "";
    }
    function onError(error: any) {
        console.error("Got error!", error);
    }
</script>

<div class="w-full text-unset text-sm relative z-0" data-testid="audio-play">
    <div
        class="absolute bg-gray-200 top-0 bottom-0"
        style="width: {playing ? $audioProgress : 0}%; z-index: -1"
    />
    <div class="p-2 flex w-full" style="z-index: 1">
        <button
            class="text-xl w-8 h-8 border-2 flex justify-center items-center hover:bg-gray-200 focus:outline-none rounded-full"
            on:click={onClick}
        >
            {#if playing}
                <span class="icon-pause" />
            {:else}<span class="icon-play" />{/if}
        </button>
        <div class="flex-1 pl-2">
            <p class="text-sm">
                {#if audio.highlighted}
                    {#each audio.highlighted as highlightedItem}
                        {#if highlightedItem.em}
                            <span class="text-primary-800 font-medium">
                                {highlightedItem.text}
                            </span>
                        {:else}<span> {highlightedItem.text} </span>{/if}
                    {/each}
                {/if}
            </p>

            <p class="text-xs text-gray-500 mt-2">
                {#if audio.dialect}
                    <span class="dialect">
                        {audio.dialect}
                    </span>
                    <span class="px-1">•</span>
                {/if}
                {audio.author.name}
            </p>
        </div>
        <div class="px-4">
            <a href="https://app.glosbe.com/audio/{getAudioId(audio)}"
                ><span class="icon-alert-circle-i" /></a
            >
        </div>
    </div>
</div>

<style>
    .dialect {
        /* font-weight: 500; */
        color: rgba(63, 63, 70, 1);
    }
    .icon-alert-circle-i {
        color: #777;
    }
</style>
